import request from '@/plugin/axios'
export function getOneclassPagedList(query) {
    return request({
        url: '/moblieapp/oneclassPagedlist',
        method: 'post',
        params: query
    })
}

export function getOneclassAgentPagedList(query) {
    return request({
        url: '/moblieapp/oneclassAgentPagedlist',
        method: 'post',
        params: query
    })
}

export function getShOneclassPagedList(query) {
    return request({
        url: '/moblieapp/shoneclassPagedlist',
        method: 'post',
        params: query
    })
}

export function getJzOneclassPagedList(query) {
    return request({
        url: '/moblieapp/jzoneclassPagedlist',
        method: 'post',
        params: query
    })
}

export function getLwOneclassPagedList(query) {
    return request({
        url: '/moblieapp/lwoneclassPagedlist',
        method: 'post',
        params: query
    })
}


export function getYeartypePagedList(query) {
    return request({
        url: '/moblieapp/yeartypePagedlist',
        method: 'post',
        params: query
    })
}


export function getYearCompanyPagedList(query) {
    return request({
        url: '/moblieapp/yearCompanyPagedlist',
        method: 'post',
        params: query
    })
}

export function getGroupCompanyPagedList(query) {
    return request({
        url: '/moblieapp/groupCompanyPagedlist',
        method: 'post',
        params: query
    })
}

export function getYearCouponPagedList(query) {
    return request({
        url: '/moblieapp/yearCouponPagedlist',
        method: 'post',
        params: query
    })
}


export function getComplaintPagedList(query) {
    return request({
        url: '/moblieapp/ComplaintPagedlist',
        method: 'post',
        params: query
    })
}


export function getTwoclassPagedList(query) {
    return request({
        url: '/moblieapp/twoclassPagedlist',
        method: 'post',
        params: query
    })
}

export function getTwoclassAgentPagedList(query) {
    return request({
        url: '/moblieapp/twoclassAgentPagedlist',
        method: 'post',
        params: query
    })
}

export function editRoleUser(data) {
    return request({
        url: '/moblieapp/editroleuser',
        method: 'post',
        data: data
    })
}
export function saveOneclass(data) {
    return request({
        url: '/moblieapp/OneclassrSave',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}

export function saveOneclassAgent(data) {
    return request({
        url: '/moblieapp/OneclassrSaveAgent',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}

export function saveShOneclass(data) {
    return request({
        url: '/moblieapp/ShOneclassrSave',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}
export function saveJzOneclass(data) {
    return request({
        url: '/moblieapp/JzOneclassrSave',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}

export function saveLwOneclass(data) {
    return request({
        url: '/moblieapp/LwOneclassrSave',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}




export function saveYeartype(data) {
    return request({
        url: '/moblieapp/YeartypeSave',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}



export function saveYearcoupon(data) {
    return request({
        url: '/moblieapp/YearcouponSave',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}


export function saveGroupCompany(data) {
    return request({
        url: '/moblieapp/GroupCompanySave',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}


export function getCompanyid(data) {
    return request({
        url: '/moblieapp/getCompanyid',
        method: 'post',
        data: data,
        loading: {
            type: 'nprogress',
            interval: 500
        }
    })
}


export function saveYearvoucher(data) {
    return request({
        url: '/moblieapp/YearvoucherSave',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}


export function saveComplaint(data) {
    return request({
        url: '/moblieapp/ComplaintSave',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}


export function saveTwoclass(data) {
    return request({
        url: '/moblieapp/TwoclassrSave',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}

export function saveTwoclassAgent(data) {
    return request({
        url: '/moblieapp/TwoclassrSaveAgent',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        success: {
            type: 'message',
            options: {
                message: '保存成功',
                type: 'success'
            }
        }
    })
}
export function updateOneclass(data) {
    return request({
        url: '/moblieapp/updateOneclass',
        method: 'post',
        data: data
    })
}

export function updateOneclassAgent(data) {
    return request({
        url: '/moblieapp/updateOneclassAgent',
        method: 'post',
        data: data
    })
}


export function updateShOneclass(data) {
    return request({
        url: '/moblieapp/updateShOneclass',
        method: 'post',
        data: data
    })
}
export function updateJzOneclass(data) {
    return request({
        url: '/moblieapp/updateJzOneclass',
        method: 'post',
        data: data
    })
}

export function updateLwOneclass(data) {
    return request({
        url: '/moblieapp/updateLwOneclass',
        method: 'post',
        data: data
    })
}


export function updateYeartype(data) {
    return request({
        url: '/moblieapp/updateYeartype',
        method: 'post',
        data: data
    })
}

export function updateTwoclass(data) {
    return request({
        url: '/moblieapp/updateTwoclass',
        method: 'post',
        data: data
    })
}

export function updateTwoclassAgent(data) {
    return request({
        url: '/moblieapp/updateTwoclassAgent',
        method: 'post',
        data: data
    })
}

export function delOneclass(data) {
    return request({
        url: '/moblieapp/oneclassDel',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delOneclassAgent(data) {
    return request({
        url: '/moblieapp/oneclassDelAgent',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}


export function delShOneclass(data) {
    return request({
        url: '/moblieapp/shOneclassDel',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}


export function delJzOneclass(data) {
    return request({
        url: '/moblieapp/jzOneclassDel',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delLwOneclass(data) {
    return request({
        url: '/moblieapp/lwOneclassDel',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}


export function delYeartype(data) {
    return request({
        url: '/moblieapp/yeartypeDel',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delYearcoupon(data) {
    return request({
        url: '/moblieapp/YearcouponDel',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delGroupCompany(data) {
    return request({
        url: '/moblieapp/GroupCompanyDel',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}


export function delYearvoucher(data) {
    return request({
        url: '/moblieapp/YearvoucherDel',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}


export function delYearcoupons(ids) {
    return request({
        url: '/user/batchdelyearcoupon',
        method: 'delete',
        params: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delGroupComanys(ids) {
    return request({
        url: '/user/batchdelGroupComany',
        method: 'delete',
        params: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delYearvouchers(ids) {
    return request({
        url: '/user/batchdelyearvoucher',
        method: 'delete',
        params: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delTwoclass(data) {
    return request({
        url: '/moblieapp/twoclassDel',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delTwoclassAgent(data) {
    return request({
        url: '/moblieapp/twoclassDelAgent',
        method: 'post',
        data: data,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}
export function delOneclasss(ids) {
    return request({
        url: '/moblieapp/batchdeloneclass',
        method: 'delete',
        params: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delOneclasssAgent(ids) {
    return request({
        url: '/moblieapp/batchdeloneclassAgent',
        method: 'delete',
        params: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delShOneclasss(ids) {
    return request({
        url: '/moblieapp/batchdelShoneclass',
        method: 'delete',
        params: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delJzOneclasss(ids) {
    return request({
        url: '/moblieapp/batchdelJzoneclass',
        method: 'delete',
        params: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delLwOneclasss(ids) {
    return request({
        url: '/moblieapp/batchdelLwoneclass',
        method: 'delete',
        params: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function delYeartypes(ids) {
    return request({
        url: '/moblieapp/batchdelyeartype',
        method: 'delete',
        params: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}

export function getOneclass(data) {
    return request({
        url: '/moblieapp/getOneclass',
        method: 'post',
        data: data,
        loading: {
            type: 'nprogress',
            interval: 500
        }
    })
}

export function getOneclassAgent(data) {
    return request({
        url: '/moblieapp/getOneclassAgent',
        method: 'post',
        data: data,
        loading: {
            type: 'nprogress',
            interval: 500
        }
    })
}

export function getTwoclass(data) {
    return request({
        url: '/moblieapp/getTwoclass',
        method: 'post',
        data: data,
        loading: {
            type: 'nprogress',
            interval: 500
        }
    })
}
export function delTwoclasss(ids) {
    return request({
        url: '/moblieapp/batchdeltwoclass',
        method: 'delete',
        params: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}
export function delTwoclasssAgent(ids) {
    return request({
        url: '/moblieapp/batchdeltwoclassAgent',
        method: 'delete',
        params: ids,
        success: {
            type: 'message',
            options: {
                message: '删除成功',
                type: 'success'
            }
        }
    })
}
